(() => {
  const eventNames = {
    view_home_section: 'gg_view_home_section',
    recommendation_click: 'gg_recommendation_click',
    routine_click: 'gg_routine_click',
    category_click: 'gg_category_click',
    need_click: 'gg_need_click',
  };

  const uuid = () =>
    globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const sessionId = (() => {
    try {
      const key = 'gg_discovery_session_id';
      const stored = sessionStorage.getItem(key);
      if (stored) return stored;
      const created = uuid();
      sessionStorage.setItem(key, created);
      return created;
    } catch (_error) {
      return uuid();
    }
  })();

  let analyticsAllowed = false;
  let trackingStarted = false;

  const refreshPrivacyState = () => {
    const customerPrivacy = globalThis.Shopify?.customerPrivacy;
    analyticsAllowed = customerPrivacy?.analyticsProcessingAllowed?.() === true;
    return analyticsAllowed;
  };

  const publish = (eventName, element) => {
    if (!refreshPrivacyState()) return;
    const analytics = globalThis.Shopify?.analytics;
    if (!analytics?.publish) return;

    const link = element.closest('a');
    const component = element.dataset.ggComponent || element.closest('[data-gg-component]')?.dataset.ggComponent || '';
    const entity = element.dataset.ggProductId || element.dataset.ggDestination || '';
    const position = element.dataset.ggPosition || '';
    const source = element.dataset.ggSource || component || document.body.className.match(/template-([\w-]+)/)?.[1] || '';
    const destination = element.dataset.ggDestination || link?.getAttribute('href') || '';

    analytics.publish(eventName, {
      event_id: uuid(),
      session_id: sessionId,
      component,
      entity,
      position,
      source,
      destination,
      context: location.pathname,
      timestamp: new Date().toISOString(),
    });
  };

  const startTracking = () => {
    if (trackingStarted || !refreshPrivacyState()) return;
    trackingStarted = true;

    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-gg-event]');
      if (!target) return;
      const eventName = eventNames[target.dataset.ggEvent];
      if (eventName) publish(eventName, target);
    });

    const homeSections = document.querySelectorAll('[data-gg-event="view_home_section"]');
    if (!homeSections.length || !('IntersectionObserver' in globalThis)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          publish(eventNames.view_home_section, entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    homeSections.forEach((section) => observer.observe(section));
  };

  const shopify = globalThis.Shopify;
  if (!shopify?.loadFeatures) return;

  shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error) return;
    startTracking();
    document.addEventListener('visitorConsentCollected', startTracking);
  });
})();
